import { yup } from '@guiker/shared-framework'

export const replacePayoutMethodSchema = yup.object({
  replaceWithId: yup.string().required(),
})
